import React, { useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { initializeUser, cleanupAuthListener } from "./util/slices/user";
import { Provider } from "react-redux";
import store from "./util/store";
import Layout from "./layout/Layout";

const LoginPage = React.lazy(() => import("./pages/LoginPage"));
const EmailSignInPage = React.lazy(() => import("./pages/EmailSignInPage"));
const Home = React.lazy(() => import("./pages/Home"));
const ConfirmProduct = React.lazy(() => import("./pages/ConfirmProduct"));
const Dashboard = React.lazy(() => import("./pages/DashboardPage"));
const PDPAuditView = React.lazy(() => import("./pages/PDPAuditView"));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage"));
const Review = React.lazy(() => import("./pages/Review"));

function AppContent() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize user state from cookies/localStorage
    dispatch(initializeUser());

    return () => {
      dispatch(cleanupAuthListener());
    };
  }, [dispatch]);

  return (
    <Router>
      <Suspense fallback={
        <div style={{display: "flex",  justifyContent: "center", alignItems: "center",}}>
          <div className="big-spinner"></div>
        </div>}>
        <Routes>
          <Route path="/" element={<Layout headerProps={{ showAvatar: false }}><LoginPage /></Layout>} />
          <Route path="/email-signin" element={<Layout headerProps={{ showAvatar: false }}><EmailSignInPage /></Layout>} />
          <Route path="/home" element={<Layout><Home /></Layout>} />
          <Route path="/confirm-product" element={<Layout><ConfirmProduct /></Layout>} />
          <Route path="/:project_id/details" element={<Layout><ConfirmProduct readOnly={true} /></Layout>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/:project_id/:run_id/audit-view" element={<PDPAuditView />} />
          <Route path="/:project_id/:run_id/review" element={<Review />} />
          <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

function MainRouter() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default MainRouter;